import type { BankRate } from "web_myplann/Calculators/Types/BankRate";
import type { CalculatorRateBar } from "web_myplann/Calculators/Types/CalculatorRateBar";

type Labels = {
	yourRate: string;
	betterCount: (count: number) => string;
	worseCount: (count: number) => string;
};

export const mapRefinancingRateBars = (
	rates: BankRate[],
	currentRate: number,
	labels: Labels,
): CalculatorRateBar[] => {
	const offered = rates.filter((rate) => rate.status === "ok");

	if (offered.length === 0) {
		return [];
	}

	const better = offered.filter((rate) => rate.rate < currentRate);
	const worse = offered.filter((rate) => rate.rate > currentRate);
	const bars: CalculatorRateBar[] = [
		{ label: labels.yourRate, rate: currentRate, isEmphasized: true },
	];

	if (better.length > 0) {
		bars.unshift({
			label: labels.betterCount(better.length),
			rate: Math.min(...better.map((rate) => rate.rate)),
			isEmphasized: false,
			isFromRate: better.length > 1,
		});
	}

	if (worse.length > 0) {
		bars.push({
			label: labels.worseCount(worse.length),
			rate: Math.min(...worse.map((rate) => rate.rate)),
			isEmphasized: false,
			isFromRate: worse.length > 1,
		});
	}

	return bars;
};
